import * as http from 'axios'

export const save = (agendamento) => http.post('/agendamento', agendamento)



// WEBPACK FOOTER //
// ./src/store/agendamento/services.js